var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c(
      "section",
      {
        staticClass: "landingPage__callout--form",
        attrs: { id: "signupForm" }
      },
      [
        _c("div", { staticClass: "callout--container" }, [
          _c("h1", [_vm._v("Sign up Today")]),
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  _vm.submitAffiliate(_vm.affiliate)
                }
              }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.affiliate.fullName,
                    expression: "affiliate.fullName"
                  }
                ],
                attrs: { type: "text", placeholder: "Full Name" },
                domProps: { value: _vm.affiliate.fullName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.affiliate, "fullName", $event.target.value)
                  }
                }
              }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.affiliate.email,
                    expression: "affiliate.email"
                  }
                ],
                attrs: { type: "email", placeholder: "Email" },
                domProps: { value: _vm.affiliate.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.affiliate, "email", $event.target.value)
                  }
                }
              }),
              _c("button", { staticClass: "btn", attrs: { type: "submit" } }, [
                _vm._v("Sign up")
              ])
            ]
          )
        ])
      ]
    ),
    _vm._m(1),
    _vm._m(2),
    _c("section", { staticClass: "landingPage__callout--form" }, [
      _c("div", { staticClass: "callout--container affiliate__form" }, [
        _c("h3", [
          _vm._v(
            "We look forward to partnering with you so be sure to get setup and started today!"
          )
        ]),
        _c(
          "form",
          {
            on: {
              submit: function($event) {
                $event.preventDefault()
                _vm.submitAffiliate(_vm.affiliate)
              }
            }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.affiliate.fullName,
                  expression: "affiliate.fullName"
                }
              ],
              attrs: { type: "text", placeholder: "Full Name" },
              domProps: { value: _vm.affiliate.fullName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.affiliate, "fullName", $event.target.value)
                }
              }
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.affiliate.email,
                  expression: "affiliate.email"
                }
              ],
              attrs: { type: "email", placeholder: "Email" },
              domProps: { value: _vm.affiliate.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.affiliate, "email", $event.target.value)
                }
              }
            }),
            _c("button", { staticClass: "btn", attrs: { type: "submit" } }, [
              _vm._v("Sign up")
            ])
          ]
        ),
        _vm._m(3)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "full__video cinemagraph__section" }, [
      _c(
        "div",
        {
          staticClass:
            "cinemagraph__content--fullWidth cinemagraph__content--mobile",
          attrs: { id: "marketers--topSection" }
        },
        [
          _c("div", { staticClass: "affiliate__content" }, [
            _c("h1", [_vm._v("Become a Flixel Affiliate Partner")]),
            _c("p", [
              _vm._v(
                "Love creating and sharing cinemagraphs? It's time to spread the love! Help us share the story of cinemagraphs and advocate for our visual storytelling tools."
              )
            ]),
            _c("p", [
              _vm._v(
                "By promoting our plans to your audience, you will earn attractive commissions on all sales you generate."
              )
            ]),
            _c("div", { staticClass: "btn__group" }, [
              _c("a", { attrs: { href: "#signupForm" } }, [
                _c("button", { staticClass: "btn btn--white" }, [
                  _vm._v("Sign up")
                ])
              ])
            ])
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "cinemagraph__content--fullWidth cinemagraph__content--desktop content__desktop--left"
        },
        [
          _c("div", { staticClass: "affiliate__content" }, [
            _c("h1", [_vm._v("Become a Flixel Affiliate Partner")]),
            _c("p", [
              _vm._v(
                "Love creating and sharing cinemagraphs? It's time to spread the love! Help us share the story of cinemagraphs and advocate for our visual storytelling tools."
              )
            ]),
            _c("p", [
              _vm._v(
                "By promoting our plans to your audience, you will earn attractive commissions on all sales you generate."
              )
            ])
          ])
        ]
      ),
      _c("div", { staticClass: "fluid__video" }, [
        _c("div", { staticClass: "video__overlay--shadow" }),
        _c("iframe", {
          attrs: {
            src:
              "https://media.flixel.com/cinemagraph/3x9pcp2urtwbk2m9ihxm?hd=true"
          }
        }),
        _c("div", { staticClass: "credit" }, [
          _c(
            "a",
            {
              attrs: { target: "_blank", href: "https://flixel.com/virgohaan/" }
            },
            [_vm._v("Virgo Haan")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "landingPage__callout landingPage__callout--white" },
      [
        _c("div", { staticClass: "callout--container callout__affiliate" }, [
          _c("h1", [_vm._v("Your benefits as a Flixel Affiliate Partner")]),
          _c("ul", [
            _c("li", [
              _vm._v(
                "Earn 10% recurring commission on every purchase made using your coupon code"
              )
            ]),
            _c("li", [_vm._v("Monthly payouts")]),
            _c("li", [_vm._v("Social sharing assets")]),
            _c("li", [_vm._v("Personal customer support")])
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "landingPage__callout" }, [
      _c("div", { staticClass: "callout--container callout__affiliate" }, [
        _c("h1", [_vm._v("Benefits for your customers")]),
        _c("ul", [
          _c("li", [_vm._v("10% off monthly and yearly plans")]),
          _c("li", [_vm._v("Access to all tutorials, tips and tricks")]),
          _c("li", [_vm._v("Personal customer support")]),
          _c("li", [
            _vm._v("Chance to be featured in galleries and on social media")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "finePrint" }, [
      _c("p", [
        _vm._v(
          "By entering your email address you agree to be part of Flixel’s mailing list and receive information and news about our products. You can opt out at any time. "
        ),
        _c("a", { attrs: { href: "/privacy" } }, [
          _vm._v("See our privacy policy")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47a92d83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a92d83","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/landingPages/affiliate/affiliate.vue
// module id = null
// module chunks = 